module.exports = __webpack_public_path__ + "img/logo.bdc71709.png";